module.exports = __webpack_public_path__ + "static/img/shop-banner-default.3784959e.png";